"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMaskOrInjectedWallet = void 0;
var react_1 = __importDefault(require("react"));
var react_loader_spinner_1 = require("react-loader-spinner");
var useMetaMaskConnector_1 = require("../connectors/useMetaMaskConnector");
var ethereum_1 = require("../utils/ethereum");
var MetaMaskOrInjectedWallet = function (_a) {
    var onSubmit = _a.onSubmit;
    var isMetaMask = (0, ethereum_1.isEthereumFromMetamask)();
    var error = (0, useMetaMaskConnector_1.useInjectedConnector)(onSubmit, isMetaMask).error;
    return (react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-justify-center" }, error ? (react_1.default.createElement("p", { className: "tw-text-red-500 tw-pb-4" }, error.message)) : (react_1.default.createElement("div", { className: "tw-my-8 tw-flex tw-items-center tw-justify-center" },
        react_1.default.createElement(react_loader_spinner_1.TailSpin, { color: "#666666", height: "60px", width: "60px" })))));
};
exports.MetaMaskOrInjectedWallet = MetaMaskOrInjectedWallet;
//# sourceMappingURL=metamask.js.map